import {LAYERDRAWER} from './LayerDrawerTypes'

const initialState = {
    layerDrawer : false
}

const LayerDrawerReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case LAYERDRAWER:
            
            return {
                layerDrawer : action.load
            }
    
        default:
          return state
    }

}

export default LayerDrawerReducer;